import React, {Component} from 'react';
import Drawer from 'material-ui/Drawer';
import Hidden from 'material-ui/Hidden';
import {withStyles} from 'material-ui/styles';
import List from 'material-ui/List';
import {ListItem, ListItemIcon, Icon, ListItemText} from "material-ui";
import {Link} from 'react-router-dom';

const drawerWidth = 240;

const styles = theme => ({
    root: {
        width: '100%',
        height: 430,
        marginTop: theme.spacing.unit * 3,
        zIndex: 1,
        overflow: 'hidden',
    },
    appFrame: {
        position: 'relative',
        display: 'flex',
        width: '100%',
        height: '100%',
    },
    appBar: {
        position: 'absolute',
        marginLeft: drawerWidth,
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerWidth}px)`,
        },
    },
    navIconHide: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    drawerHeader: theme.mixins.toolbar,
    drawerCustom: {
        position: 'fixed',
        zIndex: 9999,
    },
    drawerPaper: {
        width: 250,
        borderRight: 'none',
        [theme.breakpoints.up('md')]: {
            width: drawerWidth,
            position: 'relative',
            height: '100%',
        },
    },
    fakeItem: {
        minHeight: '64px',
        backgroundColor: theme.palette.primary.main
    },
    content: {
        backgroundColor: theme.palette.background.default,
        width: '100%',
        padding: theme.spacing.unit * 3,
        height: 'calc(100% - 56px)',
        marginTop: 56,
        [theme.breakpoints.up('sm')]: {
            height: 'calc(100% - 64px)',
            marginTop: 64,
        }
    },
    drawerHeight: {
        height: '100vh',
        backgroundColor: 'white',
        position: 'fixed',
        zIndex: 9999
    }
});

class Sidebar extends Component {

    renderItems = () => {
        const {classes} = this.props;
        return (
            <div className={classes.drawerHeader}>
                <div className={classes.fakeItem}/>
                <List>
                    <Link to={'/'}>
                        <ListItem button>
                            <ListItemIcon>
                                <Icon>home</Icon>
                            </ListItemIcon>
                            <ListItemText primary="Accueil"/>
                        </ListItem>
                    </Link>
                    <Link to={'/items'}>
                        <ListItem button>
                            <ListItemIcon>
                                <Icon>gavel</Icon>
                            </ListItemIcon>
                            <ListItemText primary="Equipements"/>
                        </ListItem>
                    </Link>
                    <Link to={'/guides'}>
                        <ListItem button>
                            <ListItemIcon>
                                <Icon>book</Icon>
                            </ListItemIcon>
                            <ListItemText primary="Guides"/>
                        </ListItem>
                    </Link>
                    <Link to={'/skins'}>
                        <ListItem button>
                            <ListItemIcon>
                                <Icon>accessibility</Icon>
                            </ListItemIcon>
                            <ListItemText primary="Skins"/>
                        </ListItem>
                    </Link>
                </List>
            </div>
        )
    };


    render() {
        const {classes} = this.props;

        return (
            <div className={classes.drawerHeight}>
                <Hidden mdUp>
                    <Drawer
                        variant="temporary"
                        anchor="left"
                        open={this.props.mobileOpen}
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        onClose={this.props.handleToggleDrawer}
                        ModalProps={{
                            keepMounted: true // better opening perf on mobile
                        }}
                        elevation={32}
                    >
                        {this.renderItems()}
                    </Drawer>
                </Hidden>
                <Hidden smDown implementation="css">
                    <Drawer
                        variant="permanent"
                        open
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        elevation={32}
                    >
                        {this.renderItems()}
                    </Drawer>
                </Hidden>
            </div>
        )
    }
};

export default withStyles(styles, {withTheme: true})(Sidebar);


// WEBPACK FOOTER //
// ./src/core/Sidebar/Sidebar.js